import { render, staticRenderFns } from "./procurement-software.vue?vue&type=template&id=58fbe1c2&"
import script from "./procurement-software.vue?vue&type=script&lang=js&"
export * from "./procurement-software.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MarketingPage1: require('/opt/build/repo/components/elements/MarketingPage1.vue').default})
